import { useState } from 'react';
import { timeline, timelineYears, type TimelineNode } from '@/mocks/gossip';

export default function Timeline() {
  const [year, setYear] = useState<number>(2026);
  const nodes: TimelineNode[] = timeline.filter((t) => t.year === year);

  return (
    <section id="timeline" className="scroll-mt-24 py-10 md:py-14 bg-background-50">
      <div className="container-site">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-1.5 rounded-full bg-accent-500"></span>
              <span className="text-xs font-medium tracking-widest text-foreground-500">EATING MELON TIMELINE</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
              吃瓜<span className="text-accent-700">时间线</span>
            </h2>
            <p className="mt-3 text-foreground-600 max-w-2xl">
              把一年的大小事件按时间顺序排开，前因后果一目了然。切到不同年份，回看那一年到底经历了什么。
            </p>
          </div>

          {/* 年份切换 */}
          <div className="flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200 self-start md:self-auto">
            {timelineYears.map((y) => (
              <button
                key={y}
                onClick={() => setYear(y)}
                className={`px-5 py-1.5 rounded-full text-sm font-medium transition whitespace-nowrap ${
                  year === y ? 'bg-foreground-950 text-background-50' : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {y}
              </button>
            ))}
          </div>
        </div>

        {/* 时间线主体 */}
        <div className="relative pl-6 md:pl-10">
          <div className="absolute left-[7px] md:left-[9px] top-2 bottom-2 w-0.5 bg-gradient-to-b from-primary-300 via-accent-300 to-background-200"></div>
          <ol className="space-y-5">
            {nodes.map((node) => (
              <li key={`${node.year}-${node.title}`} className="relative">
                <span className="absolute -left-6 md:-left-10 top-5 w-4 h-4 rounded-full bg-primary-500 border-4 border-background-50 animate-pulse-ring"></span>
                <div className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5 hover:border-primary-200 transition">
                  <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6">
                    <span className="shrink-0 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-primary-100 text-primary-700 text-sm font-semibold">
                      {node.month}
                    </span>
                    <div className="flex-1">
                      <h3 className="text-base font-semibold text-foreground-900">{node.title}</h3>
                      <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{node.desc}</p>
                    </div>
                    <div className="shrink-0 flex items-center gap-1.5 text-primary-600 text-sm">
                      <i className="ri-fire-fill"></i>
                      <span className="font-semibold">{node.heat}</span>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}